import React from 'react';
import './header.css';
import HeaderSocials from './HeaderSocials';
import CTA from './cta';
import Me from './4.2.jpg';
const Header = () => {

  return (
    <header>
      <section className="firstsection">
        <div className="container header__container" href="#home">
          <h5>Hello I'm</h5>
          <h1 className='name'>Pratham Kandari</h1>
          <h5 className="text-light">Student at University of Petroleum and Energy Studies</h5>
          <CTA />
          <img className='me' src={Me} alt="me" />
        </div>
      </section>
      <HeaderSocials />
    </header>
  )
}

export default Header